export default __webpack_public_path__ + "static/media/barra.fcbd5e1f.png";